/**
 * AuditIQ Curated HD Image Manifest
 * Every asset includes: descriptive filename, alt text, category, and URL at 1920w.
 * Sources are high-resolution, licensed-for-use photography matched to brand themes.
 */

const u = (id, w = 1920) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const BRAND_IMAGES = [
  // ---- Cybersecurity ----
  {
    key: "cyber-soc-defense-center",
    filename: "auditiq-cyber-defense-center.jpg",
    alt: "AuditIQ cyber defense center monitoring critical infrastructure",
    category: "cybersecurity",
    theme: "cyber_defense_center",
    src: u("photo-1558494949-ef010cbdcc31"),
  },
  {
    key: "cyber-network-monitoring-room",
    filename: "auditiq-network-monitoring-room.jpg",
    alt: "AuditIQ network monitoring room with real-time threat detection",
    category: "cybersecurity",
    theme: "security_operations_center",
    src: u("photo-1551808525-51a94da548ce"),
  },
  {
    key: "cyber-engineers-threat-detection",
    filename: "auditiq-cybersecurity-engineers.jpg",
    alt: "AuditIQ cybersecurity engineers reviewing threat detection dashboards",
    category: "cybersecurity",
    theme: "cybersecurity_engineers",
    src: u("photo-1573164713988-8665fc963095"),
  },
  {
    key: "cyber-threat-detection-dashboard",
    filename: "auditiq-threat-detection-dashboard.jpg",
    alt: "AuditIQ threat detection dashboard showing live network anomalies",
    category: "cybersecurity",
    theme: "threat_detection_dashboard",
    src: u("photo-1526374965328-7f61d4dc18c5"),
  },

  // ---- Water Infrastructure ----
  {
    key: "water-industrial-pumps",
    filename: "auditiq-industrial-water-pumps.jpg",
    alt: "AuditIQ protected industrial water pumps with secure PLC controllers",
    category: "water_infrastructure",
    theme: "industrial_pumps",
    src: u("photo-1581094651181-35942459ef62"),
  },
  {
    key: "water-filtration-systems",
    filename: "auditiq-water-filtration-systems.jpg",
    alt: "AuditIQ water filtration systems with sensor integrity monitoring",
    category: "water_infrastructure",
    theme: "water_filtration",
    src: u("photo-1548392651-fd22f6b3d55d"),
  },
  {
    key: "water-storage-tanks",
    filename: "auditiq-water-storage-systems.jpg",
    alt: "AuditIQ water storage systems with tamper-evident telemetry",
    category: "water_infrastructure",
    theme: "water_storage",
    src: u("photo-1534274988757-a28bf1a57c17"),
  },
  {
    key: "water-data-center-cooling",
    filename: "auditiq-data-center-cooling-loop.jpg",
    alt: "AuditIQ data center cooling loop with CyberWater Security Layer",
    category: "water_infrastructure",
    theme: "data_center_cooling",
    src: u("photo-1558494949-ef010cbdcc31"),
  },

  // ---- Government & Infrastructure ----
  {
    key: "gov-capitol-building",
    filename: "auditiq-government-capitol.jpg",
    alt: "AuditIQ serving municipal and state government transparency",
    category: "government",
    theme: "government_capitol",
    src: u("photo-1555848962-6e79363ec58f"),
  },
  {
    key: "gov-council-chamber",
    filename: "auditiq-public-council-chamber.jpg",
    alt: "AuditIQ for public council chamber budget reviews",
    category: "government",
    theme: "public_council",
    src: u("photo-1541872703-74c5e44368f9"),
  },
  {
    key: "infra-civic-bridge",
    filename: "auditiq-civic-infrastructure.jpg",
    alt: "AuditIQ civic infrastructure priority analysis",
    category: "infrastructure",
    theme: "civic_infrastructure",
    src: u("photo-1501594907352-04cda38ebc29"),
  },
  {
    key: "infra-stormwater-drainage",
    filename: "auditiq-drainage-infrastructure.jpg",
    alt: "AuditIQ drainage and stormwater infrastructure assessment",
    category: "infrastructure",
    theme: "stormwater_drainage",
    src: u("photo-1543674892-7d64d45abd30"),
  },

  // ---- Dashboard / Data ----
  {
    key: "dash-executive-analytics",
    filename: "auditiq-executive-dashboard.jpg",
    alt: "AuditIQ executive dashboard for budget and risk oversight",
    category: "dashboard",
    theme: "executive_dashboard",
    src: u("photo-1543286386-713bdd548da4"),
  },
  {
    key: "dash-ai-risk-monitor",
    filename: "auditiq-ai-risk-monitor.jpg",
    alt: "AuditIQ 24/7 AI risk monitor analyzing public-sector data",
    category: "ai_monitoring",
    theme: "ai_risk_monitor",
    src: u("photo-1677442136019-21780ecad995"),
  },
  {
    key: "dash-transparency-report",
    filename: "auditiq-transparency-reporting.jpg",
    alt: "AuditIQ public transparency reporting view for residents",
    category: "transparency",
    theme: "public_transparency",
    src: u("photo-1454165804606-c3d57bc86b40"),
  },
];

export const getImagesByCategory = (cat) =>
  BRAND_IMAGES.filter((i) => i.category === cat);

export const getImage = (key) => BRAND_IMAGES.find((i) => i.key === key);

export default BRAND_IMAGES;
